import { render, staticRenderFns } from "./ReferalCode.vue?vue&type=template&id=11f38525&scoped=true"
import script from "./ReferalCode.vue?vue&type=script&lang=js"
export * from "./ReferalCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f38525",
  null
  
)

export default component.exports